import _ from "lodash";
import $ from "jquery";

const safari = 'online_fp';
const playready = 'online_pr';
const smoothVideoPlatform = 'online';
const widevine = 'online_wv';
let platform = smoothVideoPlatform;

const testVideoElement = $(document.createElement('video'));
if (
  _.isFunction(window.WebKitMediaKeys && window.WebKitMediaKeys.isTypeSupported) &&
  window.WebKitMediaKeys.isTypeSupported("com.apple.fps.1_0", "video/mp4")
) {
  platform = safari;
} else if (!testVideoElement.mediaKeys && _.isFunction(navigator.requestMediaKeySystemAccess)) {
  navigator.requestMediaKeySystemAccess('com.widevine.alpha', [{
    initDataTypes: ['keyids', 'webm'],
    audioCapabilities: [{contentType: 'audio/webm; codecs="opus"'}],
    videoCapabilities: [{contentType: 'video/webm; codecs="vp9"'}]
  }])
    .then(() => {
      platform = widevine;
    })
    .catch(() => {
      navigator.requestMediaKeySystemAccess('com.microsoft.playready', [{
        initDataTypes: ['keyids', 'cenc'],
        audioCapabilities: [{contentType: 'audio/mp4; codecs="mp4a"'}],
        videoCapabilities: [{contentType: 'video/mp4; codecs="avc1"'}]
      }])
        .then(() => {
          platform = playready;
        });
    });
}

const getPlatform = () => {
  return platform;
};

const isSafari = (mediaUrlPlatform) => {
  return mediaUrlPlatform === safari;
};

const isSmoothVideoPlatform = (mediaUrlPlatform) => {
  return mediaUrlPlatform === smoothVideoPlatform;
};

function resolvePlatformFromUrl (mediaUrl) {
  const searchParams = new URLSearchParams(mediaUrl);
  let platformParam = 'platform';
  if (searchParams.has(platformParam)) {
    return searchParams.get(platformParam);
  }
  return smoothVideoPlatform;
}

export default {
  getPlatform,
  isSafari,
  isSmoothVideoPlatform,
  resolvePlatformFromUrl
};



// WEBPACK FOOTER //
// ./web/js/vod/platforms.js